import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=15e85db6&lang=pug&"
import script from "./Upload.vue?vue&type=script&lang=js&"
export * from "./Upload.vue?vue&type=script&lang=js&"
import style0 from "./Upload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e85db6')) {
      api.createRecord('15e85db6', component.options)
    } else {
      api.reload('15e85db6', component.options)
    }
    module.hot.accept("./Upload.vue?vue&type=template&id=15e85db6&lang=pug&", function () {
      api.rerender('15e85db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Upload.vue"
export default component.exports